import React, { useState, useRef } from "react";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import { toast } from "react-toastify";
import CloseIcon from "@mui/icons-material/Close";

// import JS files
import MuiModal from "../../shares/MuiModal";
import { fixNumbers } from "../../../utils";
import MuiComboBox from "../../shares/MuiComboBox";
import useFetch from "../../../context/useFetch";
import MuiButton from "../../shares/MuiButton";

// import Others files

const EditRingModal = (props) => {
  let windowWidth = window.screen.width;
  const [searchBased, setSearchBased] = useState("code");
  const [banglesList, setBanglesList] = useState({ results: [] });
  const [searchedBangleText, setSearchedBangleText] = useState("");
  const [selectedBangle, setSelectedBangle] = useState(undefined);

  const getListOfBanglesApi = useFetch({
    method: "get",
    url: "Bangle_Service",
    params:
      searchBased == "code"
        ? { code: fixNumbers(searchedBangleText) }
        : { name: searchedBangleText },
    argFunc: (res) => {
      setBanglesList(res);
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });
  const handleSearchedBanglesText = (text) => {
    setSearchedBangleText(text);
    if (text.length >= 1) {
      getListOfBanglesApi.reFetch();
    }
  };

  const updateOrderApi = useFetch({
    method: "patch",
    url: `OrderItem_Service/${props.orderId}`,
    trigger: false,
    data: { bangle: selectedBangle },
    argFunc: (res) => {
      // toast.success("سفارش با موفقیت  منتقل شد", {
      //   position: toast.POSITION.TOP_CENTER,
      // });
      props.setOpenModal(false);
      props.getOrderApi.reFetch();
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  return (
    <>
      <MuiModal
        openModal={props.openModal}
        setOpenModal={props.setOpenModal}
        width="w-3/5"
        isOverflow={true}
        isNotBackdropClick={true}
      >
        <div>
          <div className="close-modal-icon">
            <CloseIcon
              onClick={() => props.setOpenModal(false)}
              fontSize="large"
              color="secondary"
            />
          </div>

          <div className="flex justify-center border-b border-dashed pb-2 mb-2">
            <p className="font-bold">ویرایش النگو</p>
          </div>
          <div className="flex justify-center items-center">
            <div className="basis-1/2">
              <FormControl>
                <FormLabel id="demo-controlled-radio-buttons-group">
                  جستجو النگو براساس:
                </FormLabel>
                <RadioGroup
                  aria-labelledby="demo-controlled-radio-buttons-group"
                  name="controlled-radio-buttons-group"
                  value={searchBased}
                  onChange={(e) => {
                    setSearchBased(e.target.value);
                    setBanglesList({ results: [] });
                  }}
                >
                  <FormControlLabel
                    value="code"
                    control={<Radio />}
                    label="کد النگو"
                  />
                  <FormControlLabel
                    value="name"
                    control={<Radio />}
                    label="نام النگو"
                  />
                </RadioGroup>
              </FormControl>
            </div>
            <div className="basis-1/2">
              <MuiComboBox
                size="small"
                label="النگو"
                name="ring"
                labelId="ring-search-label"
                id="ring-search-select"
                options={banglesList.results}
                placeholder="النگو"
                setSelectedOption={setSelectedBangle}
                setSearchText={handleSearchedBanglesText}
              />
              <div className="text-left mt-4">
                <MuiButton
                  onClick={() =>
                    props.fromContext
                      ? props.handleEdit(props.orderId, selectedBangle)
                      : updateOrderApi.reFetch()
                  }
                  variant="contained"
                  color="primary"
                  text="ذخیره"
                  size="small"
                  //    icon={<ModeEditIcon />}
                />
              </div>
            </div>
          </div>
        </div>
      </MuiModal>
    </>
  );
};

export default EditRingModal;
